import { render, staticRenderFns } from "./create-region.vue?vue&type=template&id=1a8e3a4e&scoped=true&"
import script from "./create-region.vue?vue&type=script&lang=ts&"
export * from "./create-region.vue?vue&type=script&lang=ts&"
import style0 from "./create-region.vue?vue&type=style&index=0&id=1a8e3a4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8e3a4e",
  null
  
)

component.options.__file = "create-region.vue"
export default component.exports